export * from './graphql';
export * from './rest';
export * from './routes';
export * from './types';

export function dataAccess(): string {
  return 'data-access';
}
